import type {Dispatch, SetStateAction} from 'react';

export const useHandleCheckboxChange = (
  index: number,
  setFilterCategories: Dispatch<SetStateAction<number[]>>,
) => {
  setFilterCategories((prevFilterCategories) => {
    if (prevFilterCategories.includes(index)) {
      return prevFilterCategories.filter((item) => item !== index);
    }

    return [...prevFilterCategories, index];
  });
};
